import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton, Tooltip } from '@mui/material'
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined'
import { useContentBundle } from '@/hooks/useContentBundle'
import { useAuthStore } from '@/stores/authStore'
import { FeedbackDialog } from './FeedbackDialog'

/**
 * Sub-header entry point for feedback. Hidden unless BOTH the FeedbackEnabled app setting is on
 * and the user holds a role that allows submitting. The app setting rides along in the content
 * bundle and the capability in the persisted identity, so both resolve from the offline cache too.
 */
export function FeedbackButton() {
  const { t } = useTranslation()
  const { data: bundle } = useContentBundle()
  const canSubmitFeedback = useAuthStore(s => s.currentUser?.canSubmitFeedback ?? false)
  const [open, setOpen] = useState(false)

  if (!bundle?.feedbackEnabled || !canSubmitFeedback) return null

  return (
    <>
      <Tooltip title={t('feedback.title')} placement="bottom">
        <IconButton
          onClick={() => setOpen(true)}
          aria-label={t('feedback.openDialog')}
          aria-expanded={open}
          data-tour="feedback-btn"
          size="small"
          sx={{
            color: 'var(--color-on-dark-55)',
            '&:hover': { color: 'var(--color-white)', backgroundColor: 'var(--color-on-dark-10)' },
          }}
        >
          <FeedbackOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      {open && <FeedbackDialog onClose={() => setOpen(false)} />}
    </>
  )
}
